import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGraduationCap} from '@fortawesome/free-solid-svg-icons';
const Education = () =>{
	return(
		<>
			<p className="pt-3 pr-2 ">
		  		<span className="titleLogo"><FontAwesomeIcon className="fa-2x pt-2" icon={faGraduationCap} /></span>
		  		<span className="titleEducation pl-3">EDUCATION</span>
		  	</p>
		  	<div className="pt-4 pl-3">
	  			<h2 className="headings">Gomatesh Vidyapeeth</h2>
	  			<div className="row">
	  				<div className="col-md-3">
	  					<h5 className="educationtitle pl-5">SSLC</h5>
	  				</div>
	  				<div className="col-md-9">
	  				Completed SSLC from Karnataka State Secondary Education with 68%
	  				</div>
	  			</div>
	  			<h2 className="headings pt-3">Raibag Polytechnic Raibag</h2>
	  			<div className="row">
	  				<div className="col-md-3">
	  					<h5 className="educationtitle pl-5">Diploma</h5>
	  					<p className="pl-3">06/2013 - 05/2016</p>
	  				</div>
	  				<div className="col-md-9">
	  				Completed Diploma in Electrical and Electroincs Department
	  				</div>
	  			</div>
			</div>
		</>
		)
}

export default Education